module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.b3be96cb.woff";